import counterInit from "../components/_counter";

counterInit();
